import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import DriverEarnings from './DriverEarnings';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
  const title = intl.formatMessage(messages.driverEarningsHeading);

  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!restrictUrls('/siteadmin/drivers', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  const driverId = params.id;

  return {
    title,
    component: (
      <AdminLayout>
        <DriverEarnings title={title} driverId={driverId} />
      </AdminLayout>
    ),
  };
}

export default action;
